<p-messages [severity]="severity()" [id]="id()" [closable]="closable()" [enableService]="enableService()">
    <ng-template pTemplate>
        <div class="alert-container">
            @let messageIcon = icon();
            @if (messageIcon) {
                <deco-icon [iconClass]="messageIcon" [color]="null" />
            }

            <div class="template">
                @let textItems = text();
                @if (textItems) {
                    @for (text of textItems; track $index) {
                        <p [innerHTML]="text | translate"></p>
                    }
                } @else {
                    <ng-content></ng-content>
                }
            </div>
        </div>
    </ng-template>
</p-messages>
